module.exports = __webpack_public_path__ + "static/img/download.37954cb.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download.gif
// module id = 1epA
// module chunks = 0